export default "__VITE_PUBLIC_ASSET__e7d74d14__"